import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NdcCreditVoucherIssuancePageComponent } from '../component/page/forms/ndc-credit-voucher-issuance-page/ndc-credit-voucher-issuance-page.component';
import { NdcCreditVoucherRedemptionPageComponent } from '../component/page/forms/ndc-credit-voucher-redemption-page/ndc-credit-voucher-redemption-page.component';
import { NdcVoucherLogsPageComponent } from '../component/page/forms/ndc-voucher-logs-page/ndc-voucher-logs-page.component';
import { OrderChangeNotifRegistrationPageComponent } from '../component/page/forms/order-change-notif-registration-page/order-change-notif-registration-page.component';
import { AuthGuardService } from '../service/auth-guard.service';

const routes: Routes = [
  { path: 'forms/ndc-credit-voucher-issuance', component: NdcCreditVoucherIssuancePageComponent, canActivate: [AuthGuardService] },
  { path: 'forms/ndc-credit-voucher-redemption', component: NdcCreditVoucherRedemptionPageComponent, canActivate: [AuthGuardService] },
  { path: 'orderChangeNotif/register', component: OrderChangeNotifRegistrationPageComponent, canActivate: [AuthGuardService] },
  { path: 'forms/ndc-voucher-logs', component: NdcVoucherLogsPageComponent, canActivate: [AuthGuardService] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppFormsRoutingModule {}
